import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { CrmType } from '@/modules/constants';
import { MultiSelectButtons } from '../MultiSelectButtons';
export const FilterCrmTypeButtons = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    const { formatMessage } = useIntl();
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(MultiSelectButtons, { options: [
                {
                    id: String(CrmType.Customer),
                    label: formatMessage(listItemMsg('crmType', CrmType.Customer, 'Customer')),
                },
                {
                    id: String(CrmType.Prospect),
                    label: formatMessage(listItemMsg('crmType', CrmType.Prospect, 'Prospect')),
                },
                {
                    id: String(CrmType.OwnCompany),
                    label: formatMessage(listItemMsg('crmType', CrmType.OwnCompany, 'Own company')),
                },
                {
                    id: String(CrmType.Other),
                    label: formatMessage(listItemMsg('crmType', CrmType.Other, 'Other')),
                },
            ], onChange: value => {
                var _a;
                return setFilter({
                    [item]: ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0 ? value : undefined,
                });
            }, selected: activeFilters[item], fullWith: true })),
    };
};
